import NextPageBoxEditing from "./nextPageBoxEditing"
import NextPageBoxUi from "./nextPageBoxUi"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class NextPageBox extends Plugin {
  static get requires() {
    return [NextPageBoxEditing, NextPageBoxUi]
  }
}
